import { render, staticRenderFns } from "./GittigidiyorKategori.vue?vue&type=template&id=c89aa17c&scoped=true"
import script from "./GittigidiyorKategori.vue?vue&type=script&lang=js"
export * from "./GittigidiyorKategori.vue?vue&type=script&lang=js"
import style0 from "./GittigidiyorKategori.vue?vue&type=style&index=0&id=c89aa17c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89aa17c",
  null
  
)

export default component.exports